/* src/app/components/payroll/timesheets/timesheet-payroll-processing/timesheet-payroll-processing.component.css */
.table-style {
  width: 100%;
}
.custom-row-actions {
  display: flex;
  width: 100%;
}
.custom-row-actions__container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}
.comment-section,
.check-date-section {
  margin-top: 12px;
}
.field-hint {
  margin: 4px 0 8px;
  font-size: 12px;
  color: #8c8c8c;
}
.full-width {
  width: 100%;
}
.dialog-textarea {
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.required-marker {
  color: #ff4d4f;
}
.submit-run-form {
  padding: 8px 4px;
}
/*# sourceMappingURL=timesheet-payroll-processing.component-AE6YEN2Q.css.map */
